import React from 'react'

import { AcornsIcon } from '@acorns/icons'

import { TestIDs } from 'test/utils/testIds'

import { PreviewPortfolioContainer } from '../styled-components'
import BulletRowComp from './BulletRowComp'
import {
  BulletsContainer,
  DescriptionBody,
  DescriptionContainer,
  DescriptionTitle,
} from './styled-components'

type Props = {
  portfolioTheme: string
  portfolioRisk: string
  portfolioDescription: string
  product: string
  accountType?: string
}

enum LaterAccountTypesFormatted {
  ROTH_IRA = 'Roth IRA',
  TRADITIONAL_IRA = 'Traditional IRA',
  SIMPLIFIED_EMPLOYEE_PENSION = 'Simplified Employee Pension',
}

const returnLaterFormatedAccountType = (accountType: string) => {
  // Disabling ESLint for this line for no reason other than the code existed like this before this ESLint rule went into effect.
  // If you're here from the future, please resolve this ESLint error!
  // eslint-disable-next-line no-prototype-builtins
  if (LaterAccountTypesFormatted.hasOwnProperty(accountType)) {
    return LaterAccountTypesFormatted[accountType]
  }
}

const AboutYourPortfolio = (props: Props) => {
  return (
    <PreviewPortfolioContainer>
      <DescriptionContainer>
        <DescriptionTitle data-testid={TestIDs.PREVIEW_PORTFOLIO.DESCRIPTION_TITLE}>
          About your portfolio
        </DescriptionTitle>
        <DescriptionBody>{props.portfolioDescription}</DescriptionBody>
      </DescriptionContainer>
      <BulletsContainer>
        {props.product === 'Later' && (
          <BulletRowComp
            title="Account type"
            subTitle={returnLaterFormatedAccountType(props.accountType)}
            icon={AcornsIcon.Icon.ProductLater}
          />
        )}
        <BulletRowComp
          title="Risk"
          subTitle={props.portfolioRisk}
          icon={AcornsIcon.Icon.TransactionDividends}
        />
        <BulletRowComp
          title="Theme"
          subTitle={props.portfolioTheme}
          icon={AcornsIcon.Icon.UtilityNew}
        />
      </BulletsContainer>
    </PreviewPortfolioContainer>
  )
}

export default AboutYourPortfolio
